import React, { useState } from 'react';
import { Icon, Input } from 'semantic-ui-react';
import Option from './Option';

const TextInput = (props) => {
  const { option, onChange, error, tabIndex } = props;
  const [masked, setMasked] = useState(option.isPassword || false)
  return (
      <Input
        fluid
        icon={option.isPassword && <Icon name="eye" link onClick={() => setMasked(!masked)} />}
        value={Option.getValue(option)}
        onChange={(event, { value }) => onChange(value)}
        readOnly={!option.isEditable}
        type={masked ? "password" : "text"}
        autoFocus={option.setFocus}
        tabIndex={tabIndex}
        error={error}
        placeholder={option.placeHolder}
      />
  )
}

export default TextInput;